import type { SearchCandidate, WishlistOffer } from "./types";

export function alreadyAdded(candidate: SearchCandidate, offers: WishlistOffer[]): boolean {
  return offers.some(offer => offer.identity && candidate.identity
    ? offer.identity === candidate.identity
    : offer.store === candidate.store && offer.url.replace(/\/$/, "") === candidate.url.replace(/\/$/, ""));
}

export function SearchResults({ results, existingOffers, selectedIds, pendingId, actionLabel, onPick }: {
  results: SearchCandidate[]; existingOffers: WishlistOffer[]; selectedIds: string[];
  pendingId: string | null; actionLabel: string; onPick: (candidate: SearchCandidate) => void;
}) {
  return <div className="search-results">{results.map(candidate => {
    const selected = selectedIds.includes(candidate.id) || alreadyAdded(candidate, existingOffers);
    const price = candidate.price_minor === null || !candidate.currency ? "Цена не указана"
      : `${new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 }).format(candidate.price_minor / 100)} ${candidate.currency}`;
    return <article className={candidate.recommended ? "recommended" : undefined} key={candidate.id}>
      <div><strong>{candidate.title}</strong>
        {candidate.recommended ? <small className="recommendation-label">Лучшее совпадение по названию</small> : null}
        <span>{candidate.store_label}{candidate.subtitle ? ` · ${candidate.subtitle}` : ""}</span>
        <small>{price}</small>
      </div>
      <button type="button" disabled={pendingId !== null || selected} onClick={() => onPick(candidate)}>
        {selected ? "Уже в карточке" : pendingId === candidate.id ? "Добавляем…" : actionLabel}
      </button>
    </article>;
  })}</div>;
}
